import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';

@Injectable()
export class ResetPasswordService {
  constructor(private http: HttpClient) {}

  checkKeyForResetPass(keyRecovery: string): Promise<void> {
    const searchParams: HttpParams = new HttpParams().set('key', keyRecovery);

    return new Promise((resolve, reject) => {
      this.http.get(ApiLinks.checkPasswordRecoveryKey, { params: searchParams }).subscribe(() => {
        resolve(undefined);
      }, reject);
    });
  }

  setNewPassword(password: string, keyRecovery: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http.post(ApiLinks.setNewPassword, { password: password, key: keyRecovery }).subscribe(() => {
        resolve(undefined);
      }, reject);
    });

    // return this.http.get(ApiLinks.setNewPassword, { params: searchParams });
    // .map((res: Response) => Boolean(res));
  }
}
